export const NETWORKS_RESET_STATE = 'NETWORKS_RESET_STATE';
export const NETWORKS_CURRENT_ITEM = 'NETWORKS_CURRENT_ITEM';

export const NETWORKS_REQUEST_LOADING = 'NETWORKS_REQUEST_LOADING';
export const NETWORKS_REQUEST_SUCCESS = 'NETWORKS_REQUEST_SUCCESS';
export const NETWORKS_REQUEST_FAILED = 'NETWORKS_REQUEST_FAILED';

export const NETWORKS_CURRENT_ACTION = 'NETWORKS_CURRENT_ACTION';
export const NETWORKS_RESET_ACTION = 'NETWORKS_RESET_ACTION';